<div class="tile">
  <div class="header flex flex-row">
    <div *ngIf="deviceImage" class="header__device-img">
      <img src="{{ deviceImage }}" />
    </div>
    <div class="header__info flex flex-col">
      <ng-container *ngIf="subscription.registeredInstallation; else unregisteredDevice">
        <a
          data-at-installation-name
          [routerLink]="['/installations/', subscription.installationId]"
          [queryParams]="{ gatewaySerial: subscription?.gatewaySerial }"
          gtm="onGoToPage"
          gtmAction="Installation details"
          gtmCategory="bookingOverview"
        >
          <div class="header__marketing-name">
            <ng-container *ngIf="subscription.marketingName; else defaultMarketingName">
              {{ subscription.marketingName }}
            </ng-container>
            <ng-template #defaultMarketingName>
              {{ '+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF' | translate }}
              {{ subscription.ownerName }}
            </ng-template>
          </div>
        </a>
      </ng-container>
      <ng-template #unregisteredDevice>
        <p>{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.UNREGISTERED_DEVICE.TITLE' | translate }}</p>
      </ng-template>
      <p class="header__boiler-id" data-at-boiler-id>{{ subscription.boilerId }}</p>
    </div>
    <div *ngIf="isActiveSubscription" class="header__badge">
      <app-booking-package-badge
        [packageType]="subscription.trial ? BookingPlans.Trial : subscription.plan"
        size="medium"
      ></app-booking-package-badge>
    </div>
  </div>
  <div class="body flex flex-col">
    <div class="flex flex-row">
      <div class="body__row-item">{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.OWNER' | translate }}:</div>
      <div class="body__row-item">
        {{ subscription.ownerName }}
      </div>
    </div>
    <div class="flex flex-row">
      <div class="body__row-item">{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.ADDRESS' | translate }}:</div>
      <div class="body__row-item">
        {{ subscription.installationLocation }}
      </div>
    </div>
    <div class="flex flex-row">
      <div class="body__row-item">
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRES_ON' | translate }}
      </div>
      <div class="body__row-item">
        {{ subscription.expirationDate | date }}
      </div>
    </div>
    <div *ngIf="isActiveSubscription" class="flex flex-row">
      <div class="body__row-item">{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.DURATION' | translate }}:</div>
      <div class="body__row-item">
        {{ duration }} {{ '+BOOKING.OVERVIEW.VOUCHER.DAYS' | translate }}
      </div>
    </div>
    <div *ngIf="subscription.subscribedByName" class="flex flex-row">
      <div class="body__row-item">
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.BOOKING_FROM' | translate }}:
      </div>
      <div class="body__row-item">
        {{ subscription.subscribedByName }}
      </div>
    </div>
    <div *ngIf="subscription.voucher" class="flex flex-row">
      <div class="body__row-item">
        {{ '+BOOKING.OVERVIEW.VOUCHER.VOUCHER' | translate }}
      </div>
      <div class="body__row-item">
        {{ subscription.voucher }}
      </div>
    </div>
  </div>
  <div class="button">
    <button
      *ngIf="!isActiveSubscription"
      class="tile-button"
      mat-stroked-button
      gtm="onOpen"
      gtmaction="Enter voucher code for subscription"
      gtmcategory="bookingOverview"
      (click)="onRenewSubscription()"
    >
      {{ '+BOOKING.OVERVIEW.VOUCHER.ENTER_CODE' | translate }}
    </button>

    <button
      *ngIf="renewProPackage(subscription)"
      class="tile-button"
      mat-stroked-button
      gtm="onOpen"
      gtmaction="Renew pro subscription"
      gtmcategory="bookingOverview"
      (click)="onRenewSubscription()"
    >
      {{ '+BOOKING.OVERVIEW.VOUCHER.RENEW_SUBSCRIPTION' | translate }}
    </button>
  </div>
</div>
